import type { Row } from "./types.js";

/**
 * 허브 영역 UI 문자열. The source module name remains temporary internal legacy.
 * 키 접두사: comm.* / publish.*
 */
export const hubMessages = {
  // ── Hub view: 콘텐츠 종류 칩(필터) ──────────────────────────────────
  "comm.kind.all": {
    ko: "전체", "en-US": "All", ja: "すべて", zh: "全部", fr: "Tout",
    de: "Alle", es: "Todo", it: "Tutto", pt: "Tudo", "pt-BR": "Tudo",
    ru: "Все", ar: "الكل", hi: "सभी", id: "Semua",
  },
  "comm.kind.character": {
    ko: "캐릭터", "en-US": "Character", ja: "キャラクター", zh: "角色", fr: "Personnage",
    de: "Charakter", es: "Personaje", it: "Personaggio", pt: "Personagem", "pt-BR": "Personagem",
    ru: "Персонаж", ar: "شخصية", hi: "पात्र", id: "Karakter",
  },
  "comm.kind.lorebook": {
    ko: "로어북", "en-US": "Lorebook", ja: "ロアブック", zh: "设定集", fr: "Codex",
    de: "Lorebook", es: "Compendio", it: "Codex", pt: "Compêndio", "pt-BR": "Compêndio",
    ru: "Лорбук", ar: "كتاب معرفة", hi: "लोरबुक", id: "Lorebook",
  },
  "comm.kind.preset": {
    ko: "프리셋", "en-US": "Preset", ja: "プリセット", zh: "预设", fr: "Préréglage",
    de: "Preset", es: "Preajuste", it: "Preset", pt: "Predefinição", "pt-BR": "Predefinição",
    ru: "Пресет", ar: "إعداد مسبق", hi: "प्रीसेट", id: "Praatur",
  },
  "comm.kind.game": {
    ko: "게임", "en-US": "Game", ja: "ゲーム", zh: "游戏", fr: "Jeu",
    de: "Spiel", es: "Juego", it: "Gioco", pt: "Jogo", "pt-BR": "Jogo",
    ru: "Игра", ar: "لعبة", hi: "खेल", id: "Game",
  },

  // ── Hub view: 정렬 칩 ───────────────────────────────────────────────
  "comm.sort.recent": {
    ko: "최신", "en-US": "Recent", ja: "新着", zh: "最新", fr: "Récents",
    de: "Neueste", es: "Recientes", it: "Recenti", pt: "Recentes", "pt-BR": "Recentes",
    ru: "Новые", ar: "الأحدث", hi: "नवीनतम", id: "Terbaru",
  },
  "comm.sort.popular": {
    ko: "인기", "en-US": "Popular", ja: "人気", zh: "热门", fr: "Populaires",
    de: "Beliebt", es: "Populares", it: "Popolari", pt: "Populares", "pt-BR": "Populares",
    ru: "Популярные", ar: "الأكثر رواجًا", hi: "लोकप्रिय", id: "Populer",
  },
  "comm.sort.topRated": {
    ko: "평점순", "en-US": "Top rated", ja: "高評価", zh: "评分最高", fr: "Mieux notés",
    de: "Bestbewertet", es: "Mejor valorados", it: "Più votati", pt: "Mais bem avaliados", "pt-BR": "Mais bem avaliados",
    ru: "По рейтингу", ar: "الأعلى تقييمًا", hi: "शीर्ष रेटेड", id: "Rating tertinggi",
  },
  "comm.sort.downloads": {
    ko: "다운로드순", "en-US": "Most downloaded", ja: "ダウンロード数順", zh: "下载最多", fr: "Plus téléchargés",
    de: "Meiste Downloads", es: "Más descargados", it: "Più scaricati", pt: "Mais transferidos", "pt-BR": "Mais baixados",
    ru: "По загрузкам", ar: "الأكثر تنزيلًا", hi: "सर्वाधिक डाउनलोड", id: "Paling banyak diunduh",
  },
  "comm.sort.views": {
    ko: "조회수순", "en-US": "Most Viewed", ja: "閲覧数順", zh: "浏览量排序", fr: "Plus vus",
    de: "Meistgesehen", es: "Más vistos", it: "Più visti", pt: "Mais vistos", "pt-BR": "Mais vistos",
    ru: "По просмотрам", ar: "الأكثر مشاهدة", hi: "सबसे अधिक देखे गए", id: "Terbanyak dilihat",
  },
  "comm.sort.bookmarks": {
    ko: "북마크순", "en-US": "Most Bookmarked", ja: "ブックマーク順", zh: "书签排序", fr: "Plus marqués",
    de: "Meistgemerkt", es: "Más marcados", it: "Più segnati", pt: "Mais marcados", "pt-BR": "Mais marcados",
    ru: "По закладкам", ar: "الأكثر حفظاً", hi: "सबसे अधिक बुकमार्क", id: "Terbanyak ditandai",
  },

  // ── Hub view: 헤더(로그인 상태 + 게시) ──────────────────────────────
  "comm.signedInAs": {
    ko: "@{handle} 으로 로그인됨", "en-US": "Signed in as @{handle}",
    ja: "@{handle} としてログイン中", zh: "已以 @{handle} 登录",
    fr: "Connecté en tant que @{handle}", de: "Angemeldet als @{handle}",
    es: "Sesión iniciada como @{handle}", it: "Connesso come @{handle}",
    pt: "Sessão iniciada como @{handle}", "pt-BR": "Conectado como @{handle}",
    ru: "Вы вошли как @{handle}", ar: "تم تسجيل الدخول باسم @{handle}",
    hi: "@{handle} के रूप में साइन इन", id: "Masuk sebagai @{handle}",
  },
  "comm.browseWithoutLogin": {
    ko: "둘러보기는 로그인 없이 가능해요", "en-US": "Browsing is available without signing in",
    ja: "閲覧はログインなしで利用できます", zh: "无需登录即可浏览",
    fr: "La navigation est possible sans connexion", de: "Stöbern ist ohne Anmeldung möglich",
    es: "Puedes explorar sin iniciar sesión", it: "Puoi sfogliare senza accedere",
    pt: "Podes navegar sem iniciar sessão", "pt-BR": "Você pode navegar sem fazer login",
    ru: "Просмотр доступен без входа", ar: "يمكنك التصفّح دون تسجيل الدخول",
    hi: "बिना साइन इन किए ब्राउज़ कर सकते हैं", id: "Menjelajah bisa tanpa masuk",
  },
  "comm.publish": {
    ko: "+ 게시", "en-US": "+ Publish", ja: "+ 公開", zh: "+ 发布", fr: "+ Publier",
    de: "+ Veröffentlichen", es: "+ Publicar", it: "+ Pubblica", pt: "+ Publicar", "pt-BR": "+ Publicar",
    ru: "+ Опубликовать", ar: "+ نشر", hi: "+ प्रकाशित करें", id: "+ Terbitkan",
  },
  "comm.signOut": {
    ko: "로그아웃", "en-US": "Sign out", ja: "ログアウト", zh: "退出登录", fr: "Se déconnecter",
    de: "Abmelden", es: "Cerrar sesión", it: "Esci", pt: "Terminar sessão", "pt-BR": "Sair",
    ru: "Выйти", ar: "تسجيل الخروج", hi: "साइन आउट", id: "Keluar",
  },
  "comm.signIn": {
    ko: "로그인", "en-US": "Sign in", ja: "ログイン", zh: "登录", fr: "Se connecter",
    de: "Anmelden", es: "Iniciar sesión", it: "Accedi", pt: "Iniciar sessão", "pt-BR": "Entrar",
    ru: "Войти", ar: "تسجيل الدخول", hi: "साइन इन", id: "Masuk",
  },

  // ── Hub view: 검색 + 필터 ───────────────────────────────────────────
  "comm.searchPlaceholder": {
    ko: "제목·요약 검색", "en-US": "Search titles and summaries",
    ja: "タイトル・概要を検索", zh: "搜索标题和摘要",
    fr: "Rechercher titres et résumés", de: "Titel und Zusammenfassungen suchen",
    es: "Buscar títulos y resúmenes", it: "Cerca titoli e riepiloghi",
    pt: "Pesquisar títulos e resumos", "pt-BR": "Pesquisar títulos e resumos",
    ru: "Поиск по заголовкам и описаниям", ar: "ابحث في العناوين والملخّصات",
    hi: "शीर्षक और सारांश खोजें", id: "Cari judul dan ringkasan",
  },
  "comm.search": {
    ko: "검색", "en-US": "Search", ja: "検索", zh: "搜索", fr: "Rechercher",
    de: "Suchen", es: "Buscar", it: "Cerca", pt: "Pesquisar", "pt-BR": "Pesquisar",
    ru: "Найти", ar: "بحث", hi: "खोजें", id: "Cari",
  },
  "comm.sfwOnlyTitle": {
    ko: "설정에서 연령 확인 후 켤 수 있어요", "en-US": "Verify your age in settings to enable this",
    ja: "設定で年齢確認をするとオンにできます", zh: "在设置中完成年龄确认后即可开启",
    fr: "Vérifiez votre âge dans les paramètres pour l'activer", de: "Bestätige dein Alter in den Einstellungen, um dies zu aktivieren",
    es: "Verifica tu edad en los ajustes para activarlo", it: "Verifica la tua età nelle impostazioni per attivarlo",
    pt: "Verifica a tua idade nas definições para ativar", "pt-BR": "Verifique sua idade nas configurações para ativar",
    ru: "Подтвердите возраст в настройках, чтобы включить", ar: "تحقّق من عمرك في الإعدادات لتفعيل ذلك",
    hi: "इसे चालू करने के लिए सेटिंग्स में आयु सत्यापित करें", id: "Verifikasi usia di pengaturan untuk mengaktifkan",
  },
  "comm.sfwOnly": {
    ko: "SFW만 표시 중", "en-US": "Showing SFW only", ja: "SFW のみ表示中", zh: "仅显示 SFW",
    fr: "Affichage SFW uniquement", de: "Nur SFW wird angezeigt", es: "Mostrando solo SFW", it: "Solo SFW visibili",
    pt: "A mostrar apenas SFW", "pt-BR": "Exibindo apenas SFW", ru: "Показано только SFW",
    ar: "عرض المحتوى الآمن فقط", hi: "केवल SFW दिखा रहे हैं", id: "Menampilkan hanya SFW",
  },

  // ── Hub view: 목록 상태/카드 ────────────────────────────────────────
  "comm.loadFailed": {
    ko: "목록을 불러오지 못했어요.", "en-US": "Couldn't load the list.",
    ja: "一覧を読み込めませんでした。", zh: "无法加载列表。",
    fr: "Impossible de charger la liste.", de: "Liste konnte nicht geladen werden.",
    es: "No se pudo cargar la lista.", it: "Impossibile caricare l'elenco.",
    pt: "Não foi possível carregar a lista.", "pt-BR": "Não foi possível carregar a lista.",
    ru: "Не удалось загрузить список.", ar: "تعذّر تحميل القائمة.",
    hi: "सूची लोड नहीं हो सकी।", id: "Gagal memuat daftar.",
  },
  "comm.empty": {
    ko: "표시할 콘텐츠가 없어요.", "en-US": "No content to show.",
    ja: "表示するコンテンツがありません。", zh: "没有可显示的内容。",
    fr: "Aucun contenu à afficher.", de: "Keine Inhalte vorhanden.",
    es: "No hay contenido para mostrar.", it: "Nessun contenuto da mostrare.",
    pt: "Sem conteúdo para mostrar.", "pt-BR": "Nenhum conteúdo para exibir.",
    ru: "Нет контента для показа.", ar: "لا يوجد محتوى للعرض.",
    hi: "दिखाने के लिए कोई सामग्री नहीं।", id: "Tidak ada konten untuk ditampilkan.",
  },
  "comm.adult": {
    ko: "성인", "en-US": "Adult", ja: "成人向け", zh: "成人", fr: "Adulte",
    de: "18+", es: "Adulto", it: "Adulti", pt: "Adulto", "pt-BR": "Adulto",
    ru: "18+", ar: "للبالغين", hi: "वयस्क", id: "Dewasa",
  },
  "comm.downloads": {
    ko: "다운로드", "en-US": "Downloads", ja: "ダウンロード", zh: "下载", fr: "Téléchargements",
    de: "Downloads", es: "Descargas", it: "Download", pt: "Transferências", "pt-BR": "Downloads",
    ru: "Загрузки", ar: "التنزيلات", hi: "डाउनलोड", id: "Unduhan",
  },
  "comm.rating": {
    ko: "평점", "en-US": "Rating", ja: "評価", zh: "评分", fr: "Note",
    de: "Bewertung", es: "Valoración", it: "Valutazione", pt: "Avaliação", "pt-BR": "Avaliação",
    ru: "Рейтинг", ar: "التقييم", hi: "रेटिंग", id: "Rating",
  },
  "comm.comments": {
    ko: "댓글", "en-US": "Comments", ja: "コメント", zh: "评论", fr: "Commentaires",
    de: "Kommentare", es: "Comentarios", it: "Commenti", pt: "Comentários", "pt-BR": "Comentários",
    ru: "Комментарии", ar: "التعليقات", hi: "टिप्पणियाँ", id: "Komentar",
  },
  "comm.installing": {
    ko: "준비 중...", "en-US": "Preparing...", ja: "準備中...", zh: "准备中...",
    fr: "Préparation...", de: "Wird vorbereitet...", es: "Preparando...", it: "Preparazione...",
    pt: "A preparar...", "pt-BR": "Preparando...", ru: "Подготовка...", ar: "جارٍ التحضير...",
    hi: "तैयार हो रहा है...", id: "Mempersiapkan...",
  },
  "comm.install": {
    ko: "플레이", "en-US": "Play", ja: "プレイ", zh: "游玩", fr: "Jouer",
    de: "Spielen", es: "Jugar", it: "Gioca", pt: "Jogar", "pt-BR": "Jogar",
    ru: "Играть", ar: "لعب", hi: "खेलें", id: "Main",
  },
  "comm.details": {
    ko: "상세", "en-US": "Details", ja: "詳細", zh: "详情", fr: "Détails",
    de: "Details", es: "Detalles", it: "Dettagli", pt: "Detalhes", "pt-BR": "Detalhes",
    ru: "Подробнее", ar: "التفاصيل", hi: "विवरण", id: "Detail",
  },
  "comm.loadMore": {
    ko: "더 보기", "en-US": "Load more", ja: "もっと見る", zh: "加载更多", fr: "Charger plus",
    de: "Mehr laden", es: "Cargar más", it: "Carica altri", pt: "Carregar mais", "pt-BR": "Carregar mais",
    ru: "Показать ещё", ar: "تحميل المزيد", hi: "और लोड करें", id: "Muat lebih banyak",
  },

  // ── Hub view: 미구성 안내 ───────────────────────────────────────────
  "comm.notConfigured.title": {
    ko: "허브 백엔드가 아직 연결되지 않았어요", "en-US": "The Hub backend is not connected yet",
    ja: "The Hub backend is not connected yet", zh: "The Hub backend is not connected yet",
    fr: "The Hub backend is not connected yet", de: "The Hub backend is not connected yet",
    es: "The Hub backend is not connected yet", it: "The Hub backend is not connected yet",
    pt: "The Hub backend is not connected yet", "pt-BR": "The Hub backend is not connected yet",
    ru: "The Hub backend is not connected yet", ar: "The Hub backend is not connected yet",
    hi: "The Hub backend is not connected yet", id: "The Hub backend is not connected yet",
  },
  // 본문은 {url}/{anon}/{readme} 토큰 위치에 <code> 요소를 끼워 렌더한다(언어별 어순 보존).
  "comm.notConfigured.body": {
    ko: "Hub 기능은 선택사항이에요(로컬 우선). 캐릭터와 게임을 공유하거나 내려받으려면 RoQeet Hub API 백엔드를 연결하세요. 빌드 환경변수 {url} 과 {anon} 를 설정하면 이 화면이 활성화됩니다. 설정 방법은 {readme} 를 참고하세요.",
    "en-US": "Hub features are optional (local-first). To share or download characters and games, connect the RoQeet Hub API backend. Set the build environment variables {url} and {anon} to enable this screen. See {readme} for setup instructions.",
    ja: "Hub features are optional (local-first). To share or download characters and games, connect the RoQeet Hub API backend. Set the build environment variables {url} and {anon} to enable this screen. See {readme} for setup instructions.",
    zh: "Hub features are optional (local-first). To share or download characters and games, connect the RoQeet Hub API backend. Set the build environment variables {url} and {anon} to enable this screen. See {readme} for setup instructions.",
    fr: "Hub features are optional (local-first). To share or download characters and games, connect the RoQeet Hub API backend. Set the build environment variables {url} and {anon} to enable this screen. See {readme} for setup instructions.",
    de: "Hub features are optional (local-first). To share or download characters and games, connect the RoQeet Hub API backend. Set the build environment variables {url} and {anon} to enable this screen. See {readme} for setup instructions.",
    es: "Hub features are optional (local-first). To share or download characters and games, connect the RoQeet Hub API backend. Set the build environment variables {url} and {anon} to enable this screen. See {readme} for setup instructions.",
    it: "Hub features are optional (local-first). To share or download characters and games, connect the RoQeet Hub API backend. Set the build environment variables {url} and {anon} to enable this screen. See {readme} for setup instructions.",
    pt: "Hub features are optional (local-first). To share or download characters and games, connect the RoQeet Hub API backend. Set the build environment variables {url} and {anon} to enable this screen. See {readme} for setup instructions.",
    "pt-BR": "Hub features are optional (local-first). To share or download characters and games, connect the RoQeet Hub API backend. Set the build environment variables {url} and {anon} to enable this screen. See {readme} for setup instructions.",
    ru: "Hub features are optional (local-first). To share or download characters and games, connect the RoQeet Hub API backend. Set the build environment variables {url} and {anon} to enable this screen. See {readme} for setup instructions.",
    ar: "Hub features are optional (local-first). To share or download characters and games, connect the RoQeet Hub API backend. Set the build environment variables {url} and {anon} to enable this screen. See {readme} for setup instructions.",
    hi: "Hub features are optional (local-first). To share or download characters and games, connect the RoQeet Hub API backend. Set the build environment variables {url} and {anon} to enable this screen. See {readme} for setup instructions.",
    id: "Hub features are optional (local-first). To share or download characters and games, connect the RoQeet Hub API backend. Set the build environment variables {url} and {anon} to enable this screen. See {readme} for setup instructions.",
  },
  "comm.notConfigured.fileShareNote": {
    ko: "연결 전에도 캐릭터·게임을 파일/공유 코드로 주고받을 수 있어요.",
    "en-US": "Even before connecting, you can exchange characters and games via files or share codes.",
    ja: "接続前でも、キャラクターやゲームはファイルや共有コードでやり取りできます。",
    zh: "即使在连接之前，你也可以通过文件或分享码交换角色和游戏。",
    fr: "Même avant la connexion, vous pouvez échanger personnages et jeux via des fichiers ou des codes de partage.",
    de: "Auch vor der Verbindung kannst du Charaktere und Spiele über Dateien oder Teilcodes austauschen.",
    es: "Incluso antes de conectar, puedes intercambiar personajes y juegos mediante archivos o códigos para compartir.",
    it: "Anche prima della connessione, puoi scambiare personaggi e giochi tramite file o codici di condivisione.",
    pt: "Mesmo antes de ligar, podes trocar personagens e jogos por ficheiros ou códigos de partilha.",
    "pt-BR": "Mesmo antes de conectar, você pode trocar personagens e jogos por arquivos ou códigos de compartilhamento.",
    ru: "Даже до подключения вы можете обмениваться персонажами и играми через файлы или коды для обмена.",
    ar: "حتى قبل الربط، يمكنك تبادل الشخصيات والألعاب عبر الملفات أو رموز المشاركة.",
    hi: "कनेक्ट करने से पहले भी आप फ़ाइलों या शेयर कोड के ज़रिए पात्र और खेल साझा कर सकते हैं।",
    id: "Bahkan sebelum terhubung, Anda dapat bertukar karakter dan game melalui berkas atau kode berbagi.",
  },

  // ── 토스트(설치/게시 결과) ───────────────────────────────────────────
  "comm.installedToLibrary": {
    ko: "\"{title}\"을(를) 라이브러리에 추가했어요.", "en-US": "Added \"{title}\" to your library.",
    ja: "「{title}」をライブラリに追加しました。", zh: "已将“{title}”添加到您的库。",
    fr: "« {title} » ajouté à votre bibliothèque.", de: "„{title}“ wurde zur Bibliothek hinzugefügt.",
    es: "Se añadió «{title}» a tu biblioteca.", it: "«{title}» aggiunto alla tua libreria.",
    pt: "\"{title}\" foi adicionado à tua biblioteca.", "pt-BR": "\"{title}\" foi adicionado à sua biblioteca.",
    ru: "«{title}» добавлено в библиотеку.", ar: "تمت إضافة \"{title}\" إلى مكتبتك.",
    hi: "\"{title}\" आपकी लाइब्रेरी में जोड़ा गया।", id: "\"{title}\" ditambahkan ke pustaka Anda.",
  },
  "comm.installed": {
    ko: "\"{title}\"을(를) 플레이합니다.", "en-US": "Playing \"{title}\".",
    ja: "「{title}」をプレイします。", zh: "正在游玩“{title}”。",
    fr: "Lecture de « {title} ».", de: "Spiele „{title}“.",
    es: "Jugando a «{title}».", it: "In riproduzione «{title}».",
    pt: "A jogar \"{title}\".", "pt-BR": "Jogando \"{title}\".",
    ru: "Играем в «{title}».", ar: "لعب \"{title}\".",
    hi: "\"{title}\" खेल रहे हैं।", id: "Memainkan \"{title}\".",
  },
  "comm.published": {
    ko: "\"{title}\"을(를) 게시했어요.", "en-US": "Published \"{title}\".",
    ja: "「{title}」を公開しました。", zh: "已发布“{title}”。",
    fr: "« {title} » a été publié.", de: "„{title}“ wurde veröffentlicht.",
    es: "Se publicó «{title}».", it: "«{title}» pubblicato.",
    pt: "\"{title}\" foi publicado.", "pt-BR": "\"{title}\" foi publicado.",
    ru: "«{title}» опубликовано.", ar: "تم نشر \"{title}\".",
    hi: "\"{title}\" प्रकाशित किया गया।", id: "\"{title}\" diterbitkan.",
  },

  // ── 상세 다이얼로그 ──────────────────────────────────────────────────
  "comm.loadFailedShort": {
    ko: "불러오지 못했어요.", "en-US": "Couldn't load this.",
    ja: "読み込めませんでした。", zh: "无法加载。",
    fr: "Impossible de charger.", de: "Konnte nicht geladen werden.",
    es: "No se pudo cargar.", it: "Impossibile caricare.",
    pt: "Não foi possível carregar.", "pt-BR": "Não foi possível carregar.",
    ru: "Не удалось загрузить.", ar: "تعذّر التحميل.",
    hi: "लोड नहीं हो सका।", id: "Gagal memuat.",
  },
  "comm.installToLibrary": {
    ko: "플레이하기", "en-US": "Play",
    ja: "プレイする", zh: "游玩",
    fr: "Jouer", de: "Spielen",
    es: "Jugar", it: "Gioca",
    pt: "Jogar", "pt-BR": "Jogar",
    ru: "Играть", ar: "لعب",
    hi: "खेलें", id: "Main",
  },
  "comm.myRating": {
    ko: "내 평점", "en-US": "My rating", ja: "自分の評価", zh: "我的评分", fr: "Ma note",
    de: "Meine Bewertung", es: "Mi valoración", it: "La mia valutazione", pt: "A minha avaliação", "pt-BR": "Minha avaliação",
    ru: "Моя оценка", ar: "تقييمي", hi: "मेरी रेटिंग", id: "Rating saya",
  },
  "comm.starsAria": {
    ko: "{n}점", "en-US": "{n} stars", ja: "{n} 点", zh: "{n} 星", fr: "{n} étoiles",
    de: "{n} Sterne", es: "{n} estrellas", it: "{n} stelle", pt: "{n} estrelas", "pt-BR": "{n} estrelas",
    ru: "{n} звёзд", ar: "{n} نجوم", hi: "{n} सितारे", id: "{n} bintang",
  },
  "comm.loginRequired": {
    ko: "로그인 필요", "en-US": "Sign-in required", ja: "ログインが必要", zh: "需要登录",
    fr: "Connexion requise", de: "Anmeldung erforderlich", es: "Requiere iniciar sesión", it: "Accesso richiesto",
    pt: "Início de sessão necessário", "pt-BR": "Login necessário", ru: "Требуется вход",
    ar: "يلزم تسجيل الدخول", hi: "साइन इन आवश्यक", id: "Perlu masuk",
  },
  "comm.commentsWithCount": {
    ko: "댓글 {count}", "en-US": "Comments {count}", ja: "コメント {count}", zh: "评论 {count}",
    fr: "Commentaires {count}", de: "Kommentare {count}", es: "Comentarios {count}", it: "Commenti {count}",
    pt: "Comentários {count}", "pt-BR": "Comentários {count}", ru: "Комментарии {count}",
    ar: "التعليقات {count}", hi: "टिप्पणियाँ {count}", id: "Komentar {count}",
  },
  "comm.commentPlaceholder": {
    ko: "댓글 남기기", "en-US": "Leave a comment", ja: "コメントを書く", zh: "发表评论",
    fr: "Laisser un commentaire", de: "Kommentar schreiben", es: "Deja un comentario", it: "Lascia un commento",
    pt: "Deixa um comentário", "pt-BR": "Deixe um comentário", ru: "Оставить комментарий",
    ar: "اكتب تعليقًا", hi: "टिप्पणी लिखें", id: "Tinggalkan komentar",
  },
  "comm.commentPlaceholderLoggedOut": {
    ko: "로그인 후 댓글 작성", "en-US": "Sign in to comment",
    ja: "ログインしてコメント", zh: "登录后发表评论",
    fr: "Connectez-vous pour commenter", de: "Zum Kommentieren anmelden",
    es: "Inicia sesión para comentar", it: "Accedi per commentare",
    pt: "Inicia sessão para comentar", "pt-BR": "Faça login para comentar",
    ru: "Войдите, чтобы оставить комментарий", ar: "سجّل الدخول للتعليق",
    hi: "टिप्पणी के लिए साइन इन करें", id: "Masuk untuk berkomentar",
  },
  "comm.post": {
    ko: "작성", "en-US": "Post", ja: "投稿", zh: "发布", fr: "Publier",
    de: "Senden", es: "Publicar", it: "Pubblica", pt: "Publicar", "pt-BR": "Publicar",
    ru: "Отправить", ar: "نشر", hi: "पोस्ट", id: "Kirim",
  },
  "comm.firstComment": {
    ko: "첫 댓글을 남겨보세요.", "en-US": "Be the first to comment.",
    ja: "最初のコメントを書きましょう。", zh: "来发表第一条评论吧。",
    fr: "Soyez le premier à commenter.", de: "Sei der Erste, der kommentiert.",
    es: "Sé el primero en comentar.", it: "Sii il primo a commentare.",
    pt: "Sê o primeiro a comentar.", "pt-BR": "Seja o primeiro a comentar.",
    ru: "Оставьте первый комментарий.", ar: "كن أول من يعلّق.",
    hi: "टिप्पणी करने वाले पहले व्यक्ति बनें।", id: "Jadilah yang pertama berkomentar.",
  },
  "comm.close": {
    ko: "닫기", "en-US": "Close", ja: "閉じる", zh: "关闭", fr: "Fermer",
    de: "Schließen", es: "Cerrar", it: "Chiudi", pt: "Fechar", "pt-BR": "Fechar",
    ru: "Закрыть", ar: "إغلاق", hi: "बंद करें", id: "Tutup",
  },

  // ── PublishDialog ────────────────────────────────────────────────────
  "publish.title": {
    ko: "콘텐츠 게시", "en-US": "Publish content", ja: "コンテンツを公開", zh: "发布内容",
    fr: "Publier du contenu", de: "Inhalt veröffentlichen", es: "Publicar contenido", it: "Pubblica contenuto",
    pt: "Publicar conteúdo", "pt-BR": "Publicar conteúdo", ru: "Опубликовать контент",
    ar: "نشر محتوى", hi: "सामग्री प्रकाशित करें", id: "Terbitkan konten",
  },
  "publish.kind": {
    ko: "종류", "en-US": "Type", ja: "種類", zh: "类型", fr: "Type",
    de: "Typ", es: "Tipo", it: "Tipo", pt: "Tipo", "pt-BR": "Tipo",
    ru: "Тип", ar: "النوع", hi: "प्रकार", id: "Jenis",
  },
  "publish.item": {
    ko: "게시할 항목", "en-US": "Item to publish", ja: "公開する項目", zh: "要发布的项目",
    fr: "Élément à publier", de: "Zu veröffentlichendes Element", es: "Elemento a publicar", it: "Elemento da pubblicare",
    pt: "Item a publicar", "pt-BR": "Item a publicar", ru: "Элемент для публикации",
    ar: "العنصر المراد نشره", hi: "प्रकाशित करने का आइटम", id: "Item untuk diterbitkan",
  },
  "publish.noItems": {
    ko: "게시할 수 있는 항목이 없어요. 먼저 만들어 보세요.",
    "en-US": "Nothing to publish yet. Create something first.",
    ja: "公開できる項目がありません。まず作成してください。",
    zh: "暂无可发布的项目。请先创建一个。",
    fr: "Rien à publier pour l'instant. Créez quelque chose d'abord.",
    de: "Noch nichts zum Veröffentlichen. Erstelle zuerst etwas.",
    es: "Aún no hay nada que publicar. Crea algo primero.",
    it: "Niente da pubblicare per ora. Crea prima qualcosa.",
    pt: "Ainda não há nada para publicar. Cria algo primeiro.",
    "pt-BR": "Ainda não há nada para publicar. Crie algo primeiro.",
    ru: "Пока нечего публиковать. Сначала что-нибудь создайте.",
    ar: "لا يوجد ما يُنشر بعد. أنشئ شيئًا أولًا.",
    hi: "अभी प्रकाशित करने के लिए कुछ नहीं है। पहले कुछ बनाएँ।",
    id: "Belum ada yang bisa diterbitkan. Buat sesuatu dulu.",
  },
  "publish.selectPlaceholder": {
    ko: "선택하세요", "en-US": "Select one", ja: "選択してください", zh: "请选择",
    fr: "Sélectionnez", de: "Auswählen", es: "Selecciona", it: "Seleziona",
    pt: "Seleciona", "pt-BR": "Selecione", ru: "Выберите",
    ar: "اختر", hi: "चुनें", id: "Pilih",
  },
  "publish.fieldTitle": {
    ko: "제목", "en-US": "Title", ja: "タイトル", zh: "标题", fr: "Titre",
    de: "Titel", es: "Título", it: "Titolo", pt: "Título", "pt-BR": "Título",
    ru: "Заголовок", ar: "العنوان", hi: "शीर्षक", id: "Judul",
  },
  "publish.fieldSummary": {
    ko: "한 줄 요약", "en-US": "One-line summary", ja: "一行の概要", zh: "一句话摘要",
    fr: "Résumé en une ligne", de: "Einzeilige Zusammenfassung", es: "Resumen de una línea", it: "Riepilogo in una riga",
    pt: "Resumo numa linha", "pt-BR": "Resumo em uma linha", ru: "Краткое описание в одну строку",
    ar: "ملخّص في سطر واحد", hi: "एक-पंक्ति सारांश", id: "Ringkasan satu baris",
  },
  "publish.summaryPlaceholder": {
    ko: "목록에 보이는 짧은 소개", "en-US": "Short blurb shown in the list",
    ja: "一覧に表示される短い紹介", zh: "在列表中显示的简短介绍",
    fr: "Court texte affiché dans la liste", de: "Kurzer Text, der in der Liste erscheint",
    es: "Breve descripción que aparece en la lista", it: "Breve descrizione mostrata nell'elenco",
    pt: "Pequena descrição mostrada na lista", "pt-BR": "Pequena descrição exibida na lista",
    ru: "Короткое описание для списка", ar: "وصف قصير يظهر في القائمة",
    hi: "सूची में दिखने वाला छोटा परिचय", id: "Deskripsi singkat yang tampil di daftar",
  },
  "publish.fieldDescription": {
    ko: "상세 설명", "en-US": "Full description", ja: "詳細説明", zh: "详细说明",
    fr: "Description complète", de: "Ausführliche Beschreibung", es: "Descripción completa", it: "Descrizione completa",
    pt: "Descrição completa", "pt-BR": "Descrição completa", ru: "Подробное описание",
    ar: "الوصف الكامل", hi: "पूरा विवरण", id: "Deskripsi lengkap",
  },
  "publish.descriptionPlaceholder": {
    ko: "마크다운 가능", "en-US": "Markdown supported", ja: "マークダウン対応", zh: "支持 Markdown",
    fr: "Markdown pris en charge", de: "Markdown möglich", es: "Compatible con Markdown", it: "Markdown supportato",
    pt: "Markdown suportado", "pt-BR": "Markdown suportado", ru: "Поддерживается Markdown",
    ar: "يدعم Markdown", hi: "Markdown समर्थित", id: "Mendukung Markdown",
  },
  "publish.fieldTags": {
    ko: "태그 (쉼표로 구분)", "en-US": "Tags (comma-separated)",
    ja: "タグ（カンマ区切り）", zh: "标签（用逗号分隔）",
    fr: "Étiquettes (séparées par des virgules)", de: "Tags (durch Kommas getrennt)",
    es: "Etiquetas (separadas por comas)", it: "Tag (separati da virgole)",
    pt: "Etiquetas (separadas por vírgulas)", "pt-BR": "Tags (separadas por vírgulas)",
    ru: "Теги (через запятую)", ar: "وسوم (مفصولة بفواصل)",
    hi: "टैग (अल्पविराम से अलग)", id: "Tag (dipisahkan koma)",
  },
  "publish.tagsPlaceholder": {
    ko: "판타지, 모험, 로맨스", "en-US": "fantasy, adventure, romance",
    ja: "ファンタジー, 冒険, ロマンス", zh: "奇幻, 冒险, 浪漫",
    fr: "fantasy, aventure, romance", de: "Fantasy, Abenteuer, Romanze",
    es: "fantasía, aventura, romance", it: "fantasy, avventura, romance",
    pt: "fantasia, aventura, romance", "pt-BR": "fantasia, aventura, romance",
    ru: "фэнтези, приключения, романтика", ar: "خيال, مغامرة, رومانسية",
    hi: "फंतासी, साहसिक, रोमांस", id: "fantasi, petualangan, roman",
  },
  "publish.fieldRating": {
    ko: "콘텐츠 등급", "en-US": "Content rating", ja: "コンテンツ評価", zh: "内容分级",
    fr: "Classification du contenu", de: "Inhaltseinstufung", es: "Clasificación de contenido", it: "Classificazione del contenuto",
    pt: "Classificação do conteúdo", "pt-BR": "Classificação do conteúdo", ru: "Возрастная категория",
    ar: "تصنيف المحتوى", hi: "सामग्री रेटिंग", id: "Klasifikasi konten",
  },
  "publish.ratingUnrated": {
    ko: "미지정", "en-US": "Unrated", ja: "未指定", zh: "未分级", fr: "Non classé",
    de: "Keine Einstufung", es: "Sin clasificar", it: "Non classificato", pt: "Sem classificação", "pt-BR": "Sem classificação",
    ru: "Без рейтинга", ar: "غير مُصنّف", hi: "अवर्गीकृत", id: "Tanpa klasifikasi",
  },
  "publish.ratingSfw": {
    ko: "전체 이용가 (SFW)", "en-US": "Everyone (SFW)", ja: "全年齢 (SFW)", zh: "全年龄 (SFW)",
    fr: "Tout public (SFW)", de: "Für alle (SFW)", es: "Para todos (SFW)", it: "Per tutti (SFW)",
    pt: "Para todos (SFW)", "pt-BR": "Para todos (SFW)", ru: "Для всех (SFW)",
    ar: "للجميع (SFW)", hi: "सभी के लिए (SFW)", id: "Semua umur (SFW)",
  },
  "publish.ratingNsfw": {
    ko: "성인 (NSFW)", "en-US": "Adult (NSFW)", ja: "成人向け (NSFW)", zh: "成人 (NSFW)",
    fr: "Adulte (NSFW)", de: "Erwachsene (NSFW)", es: "Adulto (NSFW)", it: "Adulti (NSFW)",
    pt: "Adulto (NSFW)", "pt-BR": "Adulto (NSFW)", ru: "18+ (NSFW)",
    ar: "للبالغين (NSFW)", hi: "वयस्क (NSFW)", id: "Dewasa (NSFW)",
  },
  "publish.fieldVersion": {
    ko: "버전 (선택)", "en-US": "Version (optional)", ja: "バージョン（任意）", zh: "版本（可选）",
    fr: "Version (facultatif)", de: "Version (optional)", es: "Versión (opcional)", it: "Versione (facoltativa)",
    pt: "Versão (opcional)", "pt-BR": "Versão (opcional)", ru: "Версия (необязательно)",
    ar: "الإصدار (اختياري)", hi: "संस्करण (वैकल्पिक)", id: "Versi (opsional)",
  },
  "publish.fieldLicense": {
    ko: "라이선스 (선택)", "en-US": "License (optional)", "en-GB": "Licence (optional)",
    ja: "ライセンス（任意）", zh: "许可证（可选）",
    fr: "Licence (facultatif)", de: "Lizenz (optional)", es: "Licencia (opcional)", it: "Licenza (facoltativa)",
    pt: "Licença (opcional)", "pt-BR": "Licença (opcional)", ru: "Лицензия (необязательно)",
    ar: "الترخيص (اختياري)", hi: "लाइसेंस (वैकल्पिक)", id: "Lisensi (opsional)",
  },
  "publish.licensePlaceholder": {
    ko: "CC-BY, MIT, 자유 등", "en-US": "CC-BY, MIT, free, etc.",
    ja: "CC-BY、MIT、自由など", zh: "CC-BY、MIT、自由等",
    fr: "CC-BY, MIT, libre, etc.", de: "CC-BY, MIT, frei usw.",
    es: "CC-BY, MIT, libre, etc.", it: "CC-BY, MIT, libera, ecc.",
    pt: "CC-BY, MIT, livre, etc.", "pt-BR": "CC-BY, MIT, livre, etc.",
    ru: "CC-BY, MIT, свободная и т. д.", ar: "CC-BY، MIT، حرّ، إلخ.",
    hi: "CC-BY, MIT, मुक्त आदि", id: "CC-BY, MIT, bebas, dll.",
  },
  "publish.nsfwWarning": {
    ko: "성인(NSFW) 콘텐츠로 게시합니다. 연령 확인을 거친 사용자에게만 노출됩니다. 미성년자 대상 콘텐츠는 금지되며 위반 시 제재될 수 있습니다.",
    "en-US": "Publishing as adult (NSFW) content. It's shown only to age-verified users. Content involving minors is forbidden and violations may result in penalties.",
    ja: "成人向け（NSFW）コンテンツとして公開します。年齢確認済みのユーザーにのみ表示されます。未成年者を対象とするコンテンツは禁止されており、違反すると制裁の対象となる場合があります。",
    zh: "将作为成人（NSFW）内容发布。仅向已完成年龄确认的用户显示。涉及未成年人的内容被禁止，违规可能受到处罚。",
    fr: "Publication en tant que contenu adulte (NSFW). Visible uniquement par les utilisateurs dont l'âge est vérifié. Le contenu impliquant des mineurs est interdit et toute violation peut entraîner des sanctions.",
    de: "Wird als Erwachseneninhalt (NSFW) veröffentlicht. Nur für altersverifizierte Nutzer sichtbar. Inhalte mit Minderjährigen sind verboten; Verstöße können sanktioniert werden.",
    es: "Se publica como contenido adulto (NSFW). Solo se muestra a usuarios con la edad verificada. El contenido que involucre a menores está prohibido y las infracciones pueden conllevar sanciones.",
    it: "Pubblicazione come contenuto per adulti (NSFW). Visibile solo agli utenti con età verificata. I contenuti che coinvolgono minori sono vietati e le violazioni possono comportare sanzioni.",
    pt: "A publicar como conteúdo adulto (NSFW). Visível apenas para utilizadores com idade verificada. Conteúdo que envolva menores é proibido e as infrações podem resultar em sanções.",
    "pt-BR": "Publicando como conteúdo adulto (NSFW). Visível apenas para usuários com idade verificada. Conteúdo envolvendo menores é proibido e as infrações podem resultar em penalidades.",
    ru: "Публикуется как материал 18+ (NSFW). Показывается только пользователям с подтверждённым возрастом. Контент с участием несовершеннолетних запрещён, за нарушения возможны санкции.",
    ar: "يُنشر كمحتوى للبالغين (NSFW). يظهر فقط للمستخدمين الذين تم التحقق من أعمارهم. يُحظر المحتوى المتعلّق بالقُصّر وقد تؤدي المخالفات إلى عقوبات.",
    hi: "वयस्क (NSFW) सामग्री के रूप में प्रकाशित किया जा रहा है। यह केवल आयु-सत्यापित उपयोगकर्ताओं को दिखती है। नाबालिगों से जुड़ी सामग्री निषिद्ध है और उल्लंघन पर दंड लग सकता है।",
    id: "Diterbitkan sebagai konten dewasa (NSFW). Hanya ditampilkan kepada pengguna yang usianya terverifikasi. Konten yang melibatkan anak di bawah umur dilarang dan pelanggaran dapat dikenai sanksi.",
  },
  "publish.publishing": {
    ko: "게시 중...", "en-US": "Publishing...", ja: "公開中...", zh: "发布中...",
    fr: "Publication...", de: "Wird veröffentlicht...", es: "Publicando...", it: "Pubblicazione...",
    pt: "A publicar...", "pt-BR": "Publicando...", ru: "Публикация...", ar: "جارٍ النشر...",
    hi: "प्रकाशित हो रहा है...", id: "Menerbitkan...",
  },
  "publish.submit": {
    ko: "게시하기", "en-US": "Publish", ja: "公開する", zh: "发布", fr: "Publier",
    de: "Veröffentlichen", es: "Publicar", it: "Pubblica", pt: "Publicar", "pt-BR": "Publicar",
    ru: "Опубликовать", ar: "نشر", hi: "प्रकाशित करें", id: "Terbitkan",
  },
  "publish.errSelectItem": {
    ko: "게시할 항목을 선택하세요.", "en-US": "Select an item to publish.",
    ja: "公開する項目を選択してください。", zh: "请选择要发布的项目。",
    fr: "Sélectionnez un élément à publier.", de: "Wähle ein Element zum Veröffentlichen.",
    es: "Selecciona un elemento para publicar.", it: "Seleziona un elemento da pubblicare.",
    pt: "Seleciona um item para publicar.", "pt-BR": "Selecione um item para publicar.",
    ru: "Выберите элемент для публикации.", ar: "اختر عنصرًا لنشره.",
    hi: "प्रकाशित करने के लिए एक आइटम चुनें।", id: "Pilih item untuk diterbitkan.",
  },
  "publish.errCharacterNotFound": {
    ko: "캐릭터를 찾을 수 없습니다.", "en-US": "Character not found.",
    ja: "キャラクターが見つかりません。", zh: "找不到角色。",
    fr: "Personnage introuvable.", de: "Charakter nicht gefunden.",
    es: "Personaje no encontrado.", it: "Personaggio non trovato.",
    pt: "Personagem não encontrado.", "pt-BR": "Personagem não encontrado.",
    ru: "Персонаж не найден.", ar: "الشخصية غير موجودة.",
    hi: "पात्र नहीं मिला।", id: "Karakter tidak ditemukan.",
  },
  "publish.errLorebookNotFound": {
    ko: "로어북을 찾을 수 없습니다.", "en-US": "Lorebook not found.",
    ja: "ロアブックが見つかりません。", zh: "找不到设定集。",
    fr: "Codex introuvable.", de: "Lorebook nicht gefunden.",
    es: "Compendio no encontrado.", it: "Codex non trovato.",
    pt: "Compêndio não encontrado.", "pt-BR": "Compêndio não encontrado.",
    ru: "Лорбук не найден.", ar: "كتاب المعرفة غير موجود.",
    hi: "लोरबुक नहीं मिली।", id: "Lorebook tidak ditemukan.",
  },
  "publish.errPresetNotFound": {
    ko: "프리셋을 찾을 수 없습니다.", "en-US": "Preset not found.",
    ja: "プリセットが見つかりません。", zh: "找不到预设。",
    fr: "Préréglage introuvable.", de: "Preset nicht gefunden.",
    es: "Preajuste no encontrado.", it: "Preset non trovato.",
    pt: "Predefinição não encontrada.", "pt-BR": "Predefinição não encontrada.",
    ru: "Пресет не найден.", ar: "الإعداد المسبق غير موجود.",
    hi: "प्रीसेट नहीं मिला।", id: "Praatur tidak ditemukan.",
  },
  "publish.errGameCardNotFound": {
    ko: "게임 카드를 찾을 수 없습니다.", "en-US": "Game card not found.",
    ja: "ゲームカードが見つかりません。", zh: "找不到游戏卡。",
    fr: "Carte de jeu introuvable.", de: "Spielkarte nicht gefunden.",
    es: "Tarjeta de juego no encontrada.", it: "Scheda di gioco non trovata.",
    pt: "Cartão de jogo não encontrado.", "pt-BR": "Cartão de jogo não encontrado.",
    ru: "Игровая карта не найдена.", ar: "بطاقة اللعبة غير موجودة.",
    hi: "गेम कार्ड नहीं मिला।", id: "Kartu game tidak ditemukan.",
  },
  "publish.errUnknownKind": {
    ko: "알 수 없는 종류입니다.", "en-US": "Unknown content type.",
    ja: "不明な種類です。", zh: "未知的类型。",
    fr: "Type de contenu inconnu.", de: "Unbekannter Inhaltstyp.",
    es: "Tipo de contenido desconocido.", it: "Tipo di contenuto sconosciuto.",
    pt: "Tipo de conteúdo desconhecido.", "pt-BR": "Tipo de conteúdo desconhecido.",
    ru: "Неизвестный тип контента.", ar: "نوع محتوى غير معروف.",
    hi: "अज्ञात सामग्री प्रकार।", id: "Jenis konten tidak dikenal.",
  },
  "lint.comm.unknownKind": {
    ko: "알 수 없는 콘텐츠 종류입니다.", "en-US": "Unknown content type.",
    ja: "不明な種類です。", zh: "未知的类型。",
    fr: "Type de contenu inconnu.", de: "Unbekannter Inhaltstyp.",
    es: "Tipo de contenido desconocido.", it: "Tipo di contenuto sconosciuto.",
    pt: "Tipo de conteúdo desconhecido.", "pt-BR": "Tipo de conteúdo desconhecido.",
    ru: "Неизвестный тип контента.", ar: "نوع محتوى غير معروف.",
    hi: "अज्ञात सामग्री प्रकार।", id: "Jenis konten tidak dikenal.",
  },
  "lint.comm.titleEmpty": {
    ko: "제목을 입력하세요.", "en-US": "Please enter a title.",
    ja: "タイトルを入力してください。", zh: "请输入标题。",
    fr: "Veuillez entrer un titre.", de: "Bitte gib einen Titel ein.",
    es: "Por favor, introduce un título.", it: "Inserisci un titolo.",
    pt: "Por favor, introduza um título.", "pt-BR": "Por favor, insira um título.",
    ru: "Пожалуйста, введите заголовок.", ar: "الرجاء إدخال عنوان.",
    hi: "कृपया एक शीर्षक दर्ज करें।", id: "Harap masukkan judul.",
  },
  "lint.comm.titleTooLong": {
    ko: "제목이 너무 깁니다(최대 120자).", "en-US": "Title is too long (max 120 chars).",
    ja: "タイトルが長すぎます（最大120文字）。", zh: "标题太长（最多120个字符）。",
    fr: "Le titre est trop long (max 120 caractères).", de: "Titel ist zu lang (max. 120 Zeichen).",
    es: "El título es demasiado largo (máx. 120 caracteres).", it: "Il titolo è troppo lungo (max 120 caratteri).",
    pt: "O título é demasiado longo (máx. 120 caracteres).", "pt-BR": "O título é muito longo (máx. 120 caracteres).",
    ru: "Заголовок слишком длинный (макс. 120 символов).", ar: "العنوان طويل جدًا (120 حرفًا كحد أقصى).",
    hi: "शीर्षक बहुत लंबा है (अधिकतम 120 वर्ण)।", id: "Judul terlalu panjang (maks. 120 karakter).",
  },
  "lint.comm.invalidRating": {
    ko: "콘텐츠 등급이 올바르지 않습니다.", "en-US": "Invalid content rating.",
    ja: "コンテンツ評価が正しくありません。", zh: "无效的内容分级。",
    fr: "Classification du contenu invalide.", de: "Ungültige Inhaltseinstufung.",
    es: "Clasificación de contenido no válida.", it: "Classificazione del contenuto non valida.",
    pt: "Classificação de conteúdo inválida.", "pt-BR": "Classificação de conteúdo inválida.",
    ru: "Недопустимая категория контента.", ar: "تصنيف المحتوى غير صالح.",
    hi: "अमान्य सामग्री रेटिंग।", id: "Klasifikasi konten tidak valid.",
  },
  "lint.comm.payloadEmpty": {
    ko: "게시할 콘텐츠가 비어 있습니다.", "en-US": "Content to publish is empty.",
    ja: "公開するコンテンツが空です。", zh: "要发布的内容为空。",
    fr: "Le contenu à publier est vide.", de: "Zu veröffentlichender Inhalt ist leer.",
    es: "El contenido a publicar está vacío.", it: "Il contenuto da pubblicare è vuoto.",
    pt: "O conteúdo a publicar está vazio.", "pt-BR": "O conteúdo a ser publicado está vazio.",
    ru: "Контент для публикации пуст.", ar: "المحتوى المراد نشره فارغ.",
    hi: "प्रकाशित करने के लिए सामग्री खाली है।", id: "Konten yang akan diterbitkan kosong.",
  },
  "lint.comm.invalidPayloadFormat": {
    ko: "콘텐츠 페이로드가 올바른 형식이 아닙니다.", "en-US": "Content payload format is invalid.",
    ja: "コンテンツペイロードの形式が正しくありません。", zh: "内容负载格式无效。",
    fr: "Le format de la charge utile du contenu est invalide.", de: "Format der Inhaltsnutzdaten ist ungültig.",
    es: "El formato del payload de contenido no es válido.", it: "Il formato del payload del contenuto non è valido.",
    pt: "O formato do payload de conteúdo é inválido.", "pt-BR": "O formato do payload de conteúdo é inválido.",
    ru: "Недопустимый формат полезной нагрузки контента.", ar: "تنسيق حمولة المحتوى غير صالح.",
    hi: "सामग्री पेलोड प्रारूप अमान्य है।", id: "Format payload konten tidak valid.",
  },
  "lint.comm.invalidRatingRange": {
    ko: "평점은 1~5 사이여야 합니다.", "en-US": "Rating must be between 1 and 5.",
    ja: "評価は1〜5の間である必要があります。", zh: "评分必须在 1 到 5 之间。",
    fr: "La note doit être comprise entre 1 et 5.", de: "Die Bewertung muss zwischen 1 und 5 liegen.",
    es: "La valoración debe estar entre 1 y 5.", it: "La valutazione deve essere compresa tra 1 e 5.",
    pt: "A avaliação deve estar entre 1 e 5.", "pt-BR": "A avaliação deve ser entre 1 e 5.",
    ru: "Оценка должна быть от 1 до 5.", ar: "يجب أن يكون التقييم بين 1 و 5.",
    hi: "रेटिंग 1 और 5 के बीच होनी चाहिए।", id: "Rating harus antara 1 dan 5.",
  },
  "comm.views": { ko: "조회수", "en-US": "Views", ja: "閲覧数", zh: "浏览量", fr: "Vues", de: "Aufrufe", es: "Vistas", it: "Visualizzazioni", pt: "Visualizações", "pt-BR": "Visualizações", ru: "Просмотры", ar: "مشاهدات", hi: "दृश्य", id: "Dilihat" },
  "comm.bookmark": { ko: "북마크", "en-US": "Bookmark", ja: "ブックマーク", zh: "书签", fr: "Marquer", de: "Merken", es: "Marcar", it: "Segnalibro", pt: "Marcar", "pt-BR": "Marcar", ru: "Закладка", ar: "حفظ", hi: "बुकमार्क", id: "Tandai" },
  "comm.unbookmark": { ko: "북마크 해제", "en-US": "Unbookmark", ja: "ブックマーク解除", zh: "取消书签", fr: "Retirer", de: "Entfernen", es: "Desmarcar", it: "Rimuovi segnalibro", pt: "Desmarcar", "pt-BR": "Desmarcar", ru: "Удалить", ar: "إلغاء", hi: "अनमार्क", id: "Batal tandai" },
  "comm.bookmarks": { ko: "북마크", "en-US": "Bookmarks", ja: "ブックマーク", zh: "书签", fr: "Marqués", de: "Gemerkt", es: "Marcados", it: "Segnalibri", pt: "Marcados", "pt-BR": "Marcados", ru: "Закладки", ar: "محفوظات", hi: "बुकमार्क", id: "Ditandai" },

  "comm.edit": { ko: "수정", "en-US": "Edit", ja: "編集", zh: "编辑", fr: "Modifier", de: "Bearbeiten", es: "Editar", it: "Modifica", pt: "Editar", "pt-BR": "Editar", ru: "Редактировать", ar: "تعديل", hi: "संपादित", id: "Edit" },
  "comm.versionUp": { ko: "버전 업", "en-US": "Version Up", ja: "バージョンアップ", zh: "版本升级", fr: "Mise à jour", de: "Version erhöhen", es: "Actualizar versión", it: "Aggiorna versione", pt: "Atualizar versão", "pt-BR": "Atualizar versão", ru: "Обновить", ar: "تحديث", hi: "संस्करण", id: "Perbarui versi" },
  "comm.unpublish": { ko: "게시 취소", "en-US": "Unpublish", ja: "公開取り消し", zh: "下架", fr: "Retirer", de: "Zurückziehen", es: "Retirar", it: "Ritira", pt: "Retirar", "pt-BR": "Retirar", ru: "Снять", ar: "إلغاء النشر", hi: "अप्रकाशित", id: "Batalkan" },
  "comm.unpublishConfirm": { ko: "정말 게시을 취소하시겠습니까?", "en-US": "Are you sure you want to unpublish?", ja: "公開を取り消しますか？", zh: "确定要下架吗？", fr: "Voulez-vous vraiment retirer ?", de: "Wirklich zurückziehen?", es: "¿Seguro que quiere retirar?", it: "Vuoi davvero ritirare?", pt: "Tem certeza?", "pt-BR": "Tem certeza?", ru: "Уверены?", ar: "هل أنت متأكد؟", hi: "क्या आप सुनिश्चित हैं?", id: "Yakin ingin membatalkan?" },

  "publish.sourceVisibility": { ko: "소스코드 공개", "en-US": "Source Code", ja: "ソースコード", zh: "源代码", fr: "Code source", de: "Quellcode", es: "Código fuente", it: "Codice sorgente", pt: "Código fonte", "pt-BR": "Código fonte", ru: "Исходный код", ar: "الكоد المصدري", hi: "सोर्स कोड", id: "Kode sumber" },
  "publish.sourcePublic": { ko: "공개", "en-US": "Public", ja: "公開", zh: "公开", fr: "Public", de: "Öffentlich", es: "Público", it: "Pubblico", pt: "Público", "pt-BR": "Público", ru: "Открытый", ar: "عام", hi: "सार्वजनिक", id: "Publik" },
  "publish.sourceHidden": { ko: "비공개", "en-US": "Hidden", ja: "非公開", zh: "隐藏", fr: "Caché", de: "Versteckt", es: "Oculto", it: "Nascosto", pt: "Oculto", "pt-BR": "Oculto", ru: "Скрытый", ar: "مخفي", hi: "छिपा", id: "Tersembunyi" },

  "publish.statsPrivacy": { ko: "통계 설정", "en-US": "Statistics", ja: "統計設定", zh: "统计设置", fr: "Statistiques", de: "Statistiken", es: "Estadísticas", it: "Statistiche", pt: "Estatísticas", "pt-BR": "Estatísticas", ru: "Статистика", ar: "الإحصائيات", hi: "आँकड़े", id: "Statistik" },
  "publish.statsPublic": { ko: "공개", "en-US": "Public", ja: "公開", zh: "公开", fr: "Public", de: "Öffentlich", es: "Público", it: "Pubblico", pt: "Público", "pt-BR": "Público", ru: "Открытый", ar: "عام", hi: "सार्वजनिक", id: "Publik" },
  "publish.statsPrivate": { ko: "비공개", "en-US": "Private", ja: "非公開", zh: "私有", fr: "Privé", de: "Privat", es: "Privado", it: "Privato", pt: "Privado", "pt-BR": "Privado", ru: "Приватный", ar: "خاص", hi: "निजी", id: "Pribadi" },
  "publish.statsUncollected": { ko: "수집 안 함", "en-US": "Not Collected", ja: "収集しない", zh: "不收集", fr: "Non collecté", de: "Nicht erfasst", es: "No recopilar", it: "Non raccolto", pt: "Não coletar", "pt-BR": "Não coletar", ru: "Не собирать", ar: "لا يُجمع", hi: "नहीं एकत्र", id: "Tidak dikumpulkan" },

  "comm.authorProfile": { ko: "제작자 프로필", "en-US": "Author Profile", ja: "作者プロフィール", zh: "作者资料", fr: "Profil de l'auteur", de: "Autorenprofil", es: "Perfil del autor", it: "Profilo autore", pt: "Perfil do autor", "pt-BR": "Perfil do autor", ru: "Профиль автора", ar: "ملف المؤلف", hi: "लेखक प्रोफ़ाइल", id: "Profil penulis" },
  "comm.authorListings": { ko: "제작자의 작품", "en-US": "Author's Works", ja: "作者の作品", zh: "作者的作品", fr: "Œuvres de l'auteur", de: "Werke des Autors", es: "Obras del autor", it: "Opere dell'autore", pt: "Obras do autor", "pt-BR": "Obras do autor", ru: "Работы автора", ar: "أعمال المؤلف", hi: "लेखक की रचनाएँ", id: "Karya penulis" },
  "comm.sourceLocked": { ko: "소스코드 비공개", "en-US": "Source Hidden", ja: "ソース非公開", zh: "源码隐藏", fr: "Source cachée", de: "Quelle versteckt", es: "Fuente oculta", it: "Sorgente nascosta", pt: "Fonte oculta", "pt-BR": "Fonte oculta", ru: "Исходник скрыт", ar: "المصدر مخفي", hi: "स्रोत छिपा", id: "Sumber tersembunyi" },
  "comm.statsHidden": { ko: "통계 비공개", "en-US": "Stats Hidden", ja: "統計非公開", zh: "统计隐藏", fr: "Stats cachées", de: "Statistiken versteckt", es: "Estadísticas ocultas", it: "Statistiche nascoste", pt: "Stats ocultas", "pt-BR": "Stats ocultas", ru: "Статистика скрыта", ar: "الإحصائيات مخفية", hi: "आँकड़े छिपे", id: "Statistik tersembunyi" },

  "comm.admin.title": { ko: "관리자 패널", "en-US": "Admin Panel", ja: "管理者パネル", zh: "管理员面板", fr: "Panneau d'administration", de: "Admin-Panel", es: "Panel de administración", it: "Pannello amministratore", pt: "Painel de administração", "pt-BR": "Painel de administração", ru: "Панель админа", ar: "لوحة الإدارة", hi: "एडमिन पैनल", id: "Panel admin" },
  "comm.admin.users": { ko: "사용자 목록", "en-US": "User List", ja: "ユーザー一覧", zh: "用户列表", fr: "Liste des utilisateurs", de: "Benutzerliste", es: "Lista de usuarios", it: "Lista utenti", pt: "Lista de usuários", "pt-BR": "Lista de usuários", ru: "Список пользователей", ar: "قائمة المستخدمين", hi: "उपयोगकर्ता सूची", id: "Daftar pengguna" },
  "comm.admin.removeListing": { ko: "게시물 강제 삭제", "en-US": "Force Remove", ja: "強制削除", zh: "强制删除", fr: "Supprimer de force", de: "Erzwingen entfernen", es: "Eliminar forzosamente", it: "Rimozione forzata", pt: "Remover forçadamente", "pt-BR": "Remover forçadamente", ru: "Принудительно удалить", ar: "إزالة إجبارية", hi: "जबरदस्ती हटाना", id: "Paksa hapus" },
} satisfies Record<string, Row>;
